import { Dto } from '@core/data/dto/dto';
import { DtoExport, DtoForceConstructor, DtoImport } from '@core/utils/dto';
import { Entity } from '@core/data/dto/entity';
import { copyObjectProperties } from '@core/utils/object';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { EmployeeResidenceSchema } from './employee-residence.schema';

@DtoForceConstructor
export class EmployeeResidence implements Entity {
    public addressLine1: string;
    public addressLine2: string;
    public city: string;
    public state: string;
    public postalCode: string;

    constructor(value?: any) {
        if (value) {
            copyObjectProperties.call(this, value);
        }
    }

    @DtoImport(EmployeeResidenceSchema)
    static import(dto: Dto): any {
        return new EmployeeResidence(dto);
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: EmployeeResidence,
        },
    ])
    export(type?: DtoType): any {}
}
